module.exports = __webpack_public_path__ + "img/ic_badge_probetraining.700cd0a9.svg";